module.exports = __webpack_public_path__ + "static/media/desktop_separator_01.fa86285b.webp";